export default [
    {
        path: "/admin/approval-flows",
        name: "approval-flow",
        meta: { requiresAuth: true },
        component: () => import("@/pages/setting/approval-flow")
    }
];
